import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Common function to get access token
export function getaccessToken() {
  return localStorage.getItem("palanivel_access_token");
}

export const  backendUrl = "https://api.palaniveloverseas.com/api/"
// Common base query configuration
export const baseQuery = fetchBaseQuery({
  baseUrl: backendUrl,
  prepareHeaders: (headers, { getState }) => {
    const token = getaccessToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

// Common error transformer
export const transformErrorResponse = (response) => ({
  status: response.status,
  message: response.data?.message || "An error occurred",
});

// Common response transformer
export const transformResponse = (response) => response;

// Common error transformer with custom message
export const transformErrorResponseWithMessage = (response, meta, args) => ({
  status: response.status,
  message: response.data.message,
}); 